function Logo() {
  return <span className="logo-text sticky left-3 z-50">RS.</span>;
}

export default Logo;
